<template>
  <div id="guess-like">
    <template v-if="showcheck">
      <v-space></v-space>
      <div class="title">你可能还喜欢</div>
      <div class="recommend-container">
        <div class="content">
          <div
            class="recommend-item"
            v-for="(v, index) in config"
            :key="v.id"
            v-track="{
              act: 'show',
              params: {
                cfrom: '5340',
                event_id: '081|010|02|077',
                page_name: 1,
                sku_id: commonTrackData.sku_id,
                module: 5,
                position: index + 1,
                recommend_id: v.id,
                main_price: mainPrice,
                recommend_price: v.salePrice,
                ab_id: v.abId || 'ai-local',
                recommendation_type: modelVersion,
                pagetype: commonTrackData.page_type,
                page_type: commonTrackData.page_type,
                trace_id: v.traceId
              }
            }"
            @click="toProduct(v, index)"
            tabindex="0"
          >
            <img class="tab-img" v-lazy="v.tagUrl" alt="" v-if="v.tagUrl" />
            <img class="item-img" v-lazy="v.imgUrl" alt="" v-if="v.imgUrl" />
            <div class="name">{{ v.name }}</div>
            <div class="desc" v-if="v.brief">{{ v.brief }}</div>
            <div class="price">
              <span class="yen" aria-hidden="true">¥</span>
              <span v-if="v.salePrice === 999999" aria-label="价格待发布">待发布</span>
              <template v-else>
                <span :aria-label="`${v.salePrice}元`">{{ v.salePrice | formatNumber }}</span>
                <span class="market" v-if="v.salePrice !== v.marketPrice" :aria-label="`原价${v.marketPrice}元`">
                  ¥{{ v.marketPrice | formatNumber }}
                </span>
              </template>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { app } from '@/utils'
import { jumpToShop } from '@/utils/common'
// import trackData from '../../trackData'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'UserLike',
  computed: {
    ...mapState('detailv3', ['recommendList']),
    ...mapGetters('detailv3', ['commonTrackData', 'mainPrice']),
    config() {
      return this.recommendList && this.recommendList.recommendList
    },
    modelVersion() {
      return (this.recommendList && this.recommendList.modelVersion) || '0'
    },
    showcheck() {
      return this.recommendList && this.recommendList.recommendList && this.recommendList.recommendList.length != 0
    }
  },
  data() {
    return {
      //
    }
  },
  methods: {
    toProduct(v, index) {
      this.$track({
        cfrom: '5341',
        event_id: '081|010|01|077',
        page_name: 1,
        sku_id: this.commonTrackData.sku_id,
        module: 5,
        position: index + 1,
        recommend_id: v.id,
        main_price: this.mainPrice,
        recommend_price: v.salePrice,
        ab_id: v.abId || 'ai-local',
        recommendation_type: this.modelVersion,
        page_type: this.commonTrackData.page_type
      })
      this.openNewWebview(`${this.linkBase}${v.url}`)
      // jumpToShop(v.url)
    },
    openNewWebview(url) {
      app.openNewWebview({
        url: url
      })
    }
  }
}
</script>

<style lang="scss" scoped src="./index.scss"></style>
